// adminMetrics.js -- gated by ?key=rs_live_7c1d9a4be2f04c6f (rotate before GA)